import { supabase } from './supabase';

/**
 * Frontend-lezer voor /api/orders/kleed-tijdlijn: dezelfde bron als het
 * klantdossier (api/_lib/kleed-tijdlijn.ts + opslag-stand.ts). Types zijn
 * gekopieerd; de frontend importeert niet uit api/.
 */

export interface TijdlijnStap {
  /** ISO (UTC). */
  moment: string;
  fase: string;
  label: string;
  methode?: string;
  notitie?: string;
  medewerker?: string;
  naarStatus?: string;
  /** Afkeurreden bij nabehandelen / nogmaals-reinigen. */
  reden?: string;
  fotos?: number;
  bron: 'event' | 'legacy-event' | 'tekst' | 'afgeleid';
}

export interface OpslagStand {
  stand: 'niet-gestart' | 'gratis' | 'loopt' | 'vrijgesteld' | 'gestopt';
  anker: string | null;
  gratisTot: string | null;
  wekenBerekend: number;
  wekenInRekening: number | null;
  bedragInclBtw: number | null;
  prijsPerWeekInclBtw: number;
  gratisDagen: number;
  pauzeTot: string | null;
}

export interface KleedTijdlijnKleed {
  itemId: string;
  ref: string | null;
  type: string;
  status: string | null;
  huidigeFase: string | null;
  tijdlijn: TijdlijnStap[];
}

export interface KleedTijdlijnResult {
  woId: string;
  reference: string | null;
  status: string | null;
  opslag: OpslagStand | null;
  kleden: KleedTijdlijnKleed[];
}

async function authHeaders(): Promise<Record<string, string>> {
  const { data: { session } } = await supabase.auth.getSession();
  const h: Record<string, string> = { 'Content-Type': 'application/json' };
  if (session?.access_token) h['Authorization'] = `Bearer ${session.access_token}`;
  return h;
}

export async function fetchKleedTijdlijn(
  params: { woId: string } | { itemId: string }
): Promise<KleedTijdlijnResult> {
  const qs = 'woId' in params
    ? `woId=${encodeURIComponent(params.woId)}`
    : `itemId=${encodeURIComponent(params.itemId)}`;
  const res = await fetch(`/api/orders/kleed-tijdlijn?${qs}`, { headers: await authHeaders() });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Tijdlijn laden mislukt' }));
    throw new Error(err.error || 'Tijdlijn laden mislukt');
  }
  return res.json();
}
